// Sidebar layout constants (V2)
export const SIDEBAR = {
  width: {
    collapsed: 72,
    expanded: 277,
  },
  transition: {
    duration: 250,
    durationMs: '250ms',
    easing: 'linear',
  },
} as const;
